<div class="file">
  <div *ngIf="status === 'uploading'" class="progress file__progress">
    <div #progressBar class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div>
  </div>
  <span class="file__name">{{file.name}}</span> 
  <i class="fas fa-times file__icon" title="Не прикреплять" (click)="remove()"></i>
</div>
